/* eslint-disable import/no-extraneous-dependencies */

import { useTranslation } from 'react-i18next'
import NavigationPrompt from '@/shared/utils/NavigationPrompt'
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal'

interface LocationChangeConfirmationModalProps {
  when: boolean
}

function LocationChangeConfirmationModal(
  props: LocationChangeConfirmationModalProps
) {
  const { when } = props
  const { t } = useTranslation()
  return (
    <NavigationPrompt when={when}>
      {({ isActive, onCancel, onConfirm }) => (
        <ConfirmationModal
          title={t('LOCATION_CHANGE_MODAL.TITLE')}
          message={t('LOCATION_CHANGE_MODAL.DESCRIPTION')}
          onConfirm={onConfirm}
          onClose={onCancel}
          isOpen={isActive}
        />
      )}
    </NavigationPrompt>
  )
}
export default LocationChangeConfirmationModal
